import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
import { SOCIAL_LINKS, PERSONAL_INFO } from '../constants';

export interface ContactItem {
  link: string;
  label: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon: any; // FontAwesome IconDefinition type - version mismatch requires any
}

const data: ContactItem[] = [
  {
    link: SOCIAL_LINKS.GITHUB,
    label: 'Github',
    icon: faGithub,
  },
  {
    link: SOCIAL_LINKS.FACEBOOK,
    label: 'Facebook',
    icon: faFacebookF,
  },
  {
    link: SOCIAL_LINKS.INSTAGRAM,
    label: 'Instagram',
    icon: faInstagram,
  },
  {
    link: SOCIAL_LINKS.LINKEDIN,
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: SOCIAL_LINKS.TWITTER,
    label: 'Twitter',
    icon: faTwitter,
  },
  {
    link: `mailto:${PERSONAL_INFO.EMAIL}`,
    label: 'Email',
    icon: faEnvelope,
  },
];

export default data;
